import ExecuteAxios from "Components/ExecuteAxios/ExecuteAxios";
import Panel from "Components/Panel/Panel";
import React, { useEffect, useState } from "react";
import RightArrow from "../../../../../Components/SideBar/assets/icons/right-arrow.png"
import ApplyAttributes from "Components/ApplyAttributes/ApplyAttributes";
import AutomaticallyListedAttributes from "Components/AutomaticallyListedAttributes/AutomaticallyListedAttributes";
import ResetVariables from "Components/ResetVariables/ResetVariables";

const CostDayPanelDetail = ({
    itemInValidation,
    costDayIdSelecteds,
    onUpdateCostDayIdSelecteds,
    updating,
    dsItem,
    dsMonth,
    onUpdateInsertNewItem,
    setUpdating,
    showNewItemMonthPanel,
    handleClose,
    getButtonToShowSubtitles,
    panelListCostDay,
    updatePanelCostSpreadsheet,
    onUpdatePanelCostSpreadsheet,
    onUpdateReloadSalaryBenefitsCost
}) => {
    const [idCostDaySelected, setIdCostDaySelected] = useState(null)
    const [status, setStatus] = useState(null)
    const [quantityItem, setQuantityItem] = useState(null)
    const [valueItem, setValueItem] = useState(null)
    const [expectedQuantityItem, setExpectedQuantityItem] = useState(null)
    const [expectedValueItem, setExpectedValueItem] = useState(null)
    const [dsObservation, setDsObservation] = useState(null)
    const [total, setTotal] = useState(null)
    const [totalExpected, setTotalExpected] = useState(null)
    const [username, setUsername] = useState(null);
    const [updateDate, setUpdateDate] = useState(null);

    const [costFixListDetail, setCostFixListDetail] = useState(null);

    const attributeList = [
        { name: "status", value: status, setter: setStatus },
        { name: "id", value: idCostDaySelected, setter: setIdCostDaySelected },
        { name: "quantityItem", value: quantityItem, setter: setQuantityItem },
        { name: "expectedQtdItem", value: expectedQuantityItem, setter: setExpectedQuantityItem },
        { name: "expectedTotal", value: totalExpected, setter: setTotalExpected, readOnly: 'S', newRow: true },
        { name: "valueItem", value: valueItem, setter: setValueItem },
        { name: "expectedValue", value: expectedValueItem, setter: setExpectedValueItem },
        { name: "observation", value: dsObservation, setter: setDsObservation },
        { name: "total", value: total, setter: setTotal, readOnly: 'S' },
        { name: "username", value: username, setter: setUsername, readOnly: 'S' },
        { name: "dtUpdate", value: updateDate, setter: setUpdateDate, readOnly: 'S' }
    ];

    const setAttributesPanelDetail = async (costDayIdSelected) => {
        const parameters = { id: costDayIdSelected }
        const costDay = await ExecuteAxios.api('get', `/cost-day/cost-day-by-id/`, { params: parameters })
        setCostFixListDetail(costDay)
        if (costDay) {
            ApplyAttributes.applyAttributes(costDay, attributeList)
        }

        if (!costDayIdSelected || costDayIdSelected.length === 0) {
            ResetVariables.resetVariables(attributeList);
        }
    };

    useEffect(() => {
        if (costDayIdSelecteds && costDayIdSelecteds.length === 1) {
            setAttributesPanelDetail(costDayIdSelecteds[0])
        } else {
            setAttributesPanelDetail(null)
        }
    }, [costDayIdSelecteds, updating]);

    async function putCostDay() {
        if (costDayIdSelecteds && costDayIdSelecteds.length === 1) {
            const response = await ExecuteAxios.api('put', `/cost-day/update-unique-selected-month/`, {
                id: idCostDaySelected,
                itemId: itemInValidation.key,
                quantityItem: quantityItem,
                valueItem: valueItem,
                expectedQuantityItem: expectedQuantityItem,
                expectedValue: expectedValueItem,
                observation: dsObservation
            });

            if (response) {
                onUpdatePanelCostSpreadsheet(true)
                onUpdateReloadSalaryBenefitsCost(true)
            }

            return response;
        }
    }

    const costDayStyle = {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        height: '95%',
        zIndex: '0',
        overflow: 'hidden'
    }

    function getContentPanel() {
        if (!updating) {
            return panelListCostDay
        } else {
            return (
                <AutomaticallyListedAttributes
                    list={costFixListDetail}
                    attributeList={attributeList}
                    readOnlyAttributes={!updating}
                />
            )
        }
    }

    async function deleteCostDay() {
        if (costDayIdSelecteds) {
            const parameters = { idsSelected: costDayIdSelecteds.join(",") };
            const response = await ExecuteAxios.api('delete', `/cost-day/delete-by-id/`, { params: parameters });

            if (response) {
                onUpdatePanelCostSpreadsheet(true)
                onUpdateReloadSalaryBenefitsCost(true)
                onUpdateCostDayIdSelecteds([])
            }
            return response
        }
    }

    return (
        <Panel titlePage={dsMonth + ' - ' + dsItem}
            style={costDayStyle}
            canViewCRUD={true}
            updating={updating}
            setInserting={onUpdateInsertNewItem}
            setUpdating={setUpdating}
            enableNewRecord={true}
            canNewRecord={(!showNewItemMonthPanel && ![4, 5, 6].includes(itemInValidation.key))}
            enableEdit={true}
            canEdit={costDayIdSelecteds && costDayIdSelecteds.length === 1}
            putFunction={putCostDay}
            deleteFunction={deleteCostDay}
            recordsSelected={costDayIdSelecteds}
            enableDelete={true}
            canDelete={costDayIdSelecteds && costDayIdSelecteds.length > 0}
            componentRightButtons={(updating || showNewItemMonthPanel) ? null :
                <button
                    style={{
                        backgroundImage: `url(${RightArrow})`,
                        backgroundSize: '30px 30px',
                        width: '35px',
                        height: '35px',
                        backgroundRepeat: 'no-repeat',
                        backgroundColor: 'transparent',
                        border: 'none',
                        cursor: 'pointer',
                        alignItems: 'center'
                    }}
                    onClick={handleClose}
                />
            }
            subtitlesPanelBottom={getButtonToShowSubtitles()}
            dataListedAttributes={costFixListDetail}
            attributeList={attributeList}
        >
            {getContentPanel()}
        </Panel>
    )
}

export default CostDayPanelDetail;